import React, { useState } from 'react';
import { Platform, Linking, Modal, TextInput, Text, View, TouchableOpacity, StyleSheet } from 'react-native';
import CachedImage from '../CachedImage';
import { FaRegEdit } from "react-icons/fa";
import { IoMdArrowDropupCircle, IoMdArrowDropdownCircle } from "react-icons/io";
import { RiMailSendFill, RiWhatsappFill } from "react-icons/ri";



function PrenotaModal({ p, contacts, modalVisible, setModalVisible }) {
  const [nomeCognome, setNomeCognome] = useState('');
  const [doveQuando, setDoveQuando] = useState('');

  function getPrenotazioneText() {
    const argomento = 'Richiesta Prenotazione Album';
    const richiesta = `Salve,\nsono ${nomeCognome}.\n\nSono interessato al seguente prodotto:\n  tipo: ${p.tipologia}\n  titolo: ${p.titolo}\n  autore: ${p.autore}\n  note: ${p.note}\n\nVorrei ritirare il prodotto:\n${doveQuando}\n\nCordiali saluti.`;
    const prenotazione = {
      argomento: argomento,
      richiesta: richiesta
    };
    return prenotazione;
  }

  const redirectEmail = () => {
    const prenotazione = getPrenotazioneText();
    const emailTo = encodeURIComponent(contacts.email);
    const subject = encodeURIComponent(prenotazione.argomento);
    const body = encodeURIComponent(prenotazione.richiesta);

    const url = `mailto:${emailTo}?subject=${subject}&body=${body}`;
    //console.log(url)

    if (Platform.OS === 'web') {
      window.location.href = url;
    } else {
      Linking.openURL(url)
        .catch(err => console.error('An error occurred', err));
    }
    setModalVisible(false);
  };

  const redirectWhatsapp = () => {
    const prenotazione = getPrenotazioneText();
    const text = encodeURIComponent(prenotazione.argomento + "\n" + prenotazione.richiesta);

    const url = `https://wa.me/${contacts.telefono}?text=${text}`;
    //console.log(url)

    Linking.openURL(url)
      .catch(err => console.error('An error occurred', err));
    setModalVisible(false);
  };

  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={modalVisible}
      onRequestClose={() => {
        setModalVisible(!modalVisible);
      }}
    >
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <Text style={styles.modalTitle}>Prenota Album</Text>

          <Text style={styles.labelText}>Inserisci il tuo nome e cognome</Text>
          <TextInput
            style={styles.textInput}
            placeholder="Nome e Cognome"
            value={nomeCognome}
            onChangeText={setNomeCognome}
            placeholderTextColor="#999"
            aria-label="Inserisci Nome e Cognome"
          />

          <Text style={styles.labelText}>In che occasione vorresti ritirare l'album</Text>
          <Text style={styles.labelText}>"{p.titolo}"?</Text>
          <Text style={styles.labelText}>Specifica uno dei nostri mercati abituali o un evento a cui parteciperemo</Text>
          <TextInput
            style={styles.textArea}
            placeholder="Dove e Quando"
            value={doveQuando}
            onChangeText={setDoveQuando}
            placeholderTextColor="#999"
            aria-label="Inserisci Dove e Quando"
            multiline={true}
          />

          <View style={styles.buttonContainer}>
            <TouchableOpacity style={styles.modalButton} onPress={() => setModalVisible(false)}>
              <Text style={styles.buttonTextStyle}>Chiudi</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.modalButton, (!nomeCognome || !doveQuando) ? styles.buttonDisabled : null]}
              onPress={redirectEmail} disabled={!nomeCognome || !doveQuando}>
              <Text style={styles.buttonTextStyle}><RiMailSendFill /> Prenota via email</Text>
            </TouchableOpacity>
          </View>
          {/* 
          <View style={styles.buttonContainer}>
            <View style={styles.buttonIncolumn}>
              <TouchableOpacity style={styles.modalButton} onPress={() => setModalVisible(false)}>
                <Text style={styles.buttonTextStyle}>Chiudi</Text>
              </TouchableOpacity>
            </View>
            <View style={styles.buttonIncolumn}>
              <TouchableOpacity
                style={[styles.modalButton, (!nomeCognome || !doveQuando) ? styles.buttonDisabled : null]}
                onPress={redirectEmail} disabled={!nomeCognome || !doveQuando}>
                <Text style={styles.buttonTextStyle}><RiMailSendFill /> Prenota via email</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.modalButton, (!nomeCognome || !doveQuando) ? styles.buttonDisabled : null, { marginTop: 10 }]}
                onPress={redirectWhatsapp} disabled={!nomeCognome || !doveQuando}>
                <Text style={styles.buttonTextStyle}><RiWhatsappFill /> Prenota via whatsapp</Text>
              </TouchableOpacity>
            </View>
          </View>
          */}

        </View>
      </View>
    </Modal>
  );
}



export default function Product({ p, contacts }) {
  const [expanded, setExpanded] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  function showSongs() {
    return () => {
      setExpanded(!expanded);
    };
  }

  return (
    <View style={styles.card}>
      <View style={styles.cardSection}>
        <View style={styles.imageContainer}>
          {p.urlImg ? (
            <img
              src={p.urlImg}
              style={styles.image}
              alt={p.title} />
          ) : (
            <CachedImage
              source={p.tipologia}
              style={styles.image}
              alt={p.tipologia}
            />
          )}
          <Text style={styles.caption}>{p.tipologia}</Text>
        </View>
        <View style={styles.info}>
          <Text style={styles.title}>{p.titolo}</Text>
          <Text>{p.autore}</Text>
          <Text>genere: {p.genere}</Text>
          <Text>prezzo di listino: €
            {(() => {
              if (p.listino.toString().includes(',')) {
                return p.listino;
              } else {
                return p.listino + ',00';
              }
            })()}
          </Text>
          {p.note ? (
            <Text>{p.note}</Text>
          ) : null
          }

          <View style={styles.cardButtonContainer}>
            <TouchableOpacity style={styles.cardButton} onPress={() => setModalVisible(true)}>
              <Text style={styles.buttonTextStyle}><FaRegEdit /> Prenota Album</Text>
            </TouchableOpacity>
          </View>

          {modalVisible ? (
            <PrenotaModal
              modalVisible={modalVisible}
              setModalVisible={setModalVisible}
              p={p}
              contacts={contacts}
            />
          ) : null
          }


          {p.tracks ? (
            <View style={styles.cardButtonContainer}>
              <TouchableOpacity style={styles.cardButton} onPress={showSongs()}>
                <Text style={styles.buttonTextStyle}>
                  {expanded ?
                    (<>
                      <IoMdArrowDropupCircle /> Nascondi Canzoni
                    </>)
                    :
                    (<>
                      <IoMdArrowDropdownCircle /> Visualizza Canzoni
                    </>)
                  }
                </Text>
              </TouchableOpacity>
            </View>
          ) : null
          }
        </View>
      </View>
      <View style={styles.songs}>
        {expanded ? (
          <>
            {p.tracks.map((track, index) => (
              <View key={index} style={styles.sectionSong}>
                <Text style={styles.songText} numberOfLines={1} ellipsizeMode="tail">- {track}</Text>
              </View>
            ))}
          </>
        ) : null
        }
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 15,
    overflow: 'hidden',
    marginBottom: 10,
    minHeight: 110,
    backgroundColor: '#fff',
  },
  cardSection: {
    flexDirection: 'row'
  },
  imageContainer: {
    width: 110,
    height: 110,
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: '65%',
    height: '65%',
    resizeMode: 'cover'
  },
  caption: {
    textAlign: 'center',
    fontSize: 10,
    marginTop: 2,
  },
  info: {
    flex: 1,
    paddingTop: 10,
    paddingHorizontal: 10,
  },
  songs: {
    flex: 1,
    flexDirection: 'column',
    paddingBottom: 10,
    paddingHorizontal: 10,
    marginTop: 3,
  },
  title: {
    fontWeight: 'bold',
  },
  showSongsText: {
    minHeight: 10,
    paddingTop: 2,
    textAlign: 'right',
    textDecorationLine: 'underline',
    color: 'lightblue',
  },
  sectionSong: {
    paddingLeft: 20,
    flex: 1,
    flexDirection: 'row',
  },
  songText: {
    flexDirection: 'row',
    fontSize: 14,
  },
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalView: {
    width: '90%',
    margin: 20,
    backgroundColor: "white",
    borderRadius: 20,
    padding: 20,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    marginBottom: 300,
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5
  },
  modalTitle: {
    marginBottom: 15,
    fontSize: 20,
    textAlign: "center",
    fontWeight: 'bold',
  },
  labelText: {
    width: '100%',
    textAlign: "left",
  },
  textInput: {
    width: '100%',
    height: 30,
    borderRadius: 15,
    backgroundColor: '#f0f0f0',
    paddingHorizontal: 20,
    marginBottom: 8,
    marginTop: 3,
    borderColor: '#ccc',
    borderWidth: 1,
  },
  textArea: {
    width: '100%',
    height: 80,
    borderRadius: 15,
    backgroundColor: '#f0f0f0',
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderColor: '#ccc',
    borderWidth: 1,
    verticalAlign: 'top',
    marginTop: 3,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    paddingHorizontal: 10,
    marginTop: 10,
  },
  buttonIncolumn: {
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  modalButton: {
    backgroundColor: '#637aff',
    borderRadius: 20,
    paddingVertical: 5,
    padding: 10,
    elevation: 2,
  },
  buttonTextStyle: {
    color: "white",
    fontWeight: "bold",
    textAlign: "center"
  },
  buttonDisabled: {
    backgroundColor: '#ccc', // Lighter color indicating the button is disabled
  },
  cardButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingRight: 10,
    marginTop: 5,
  },
  cardButton: {
    backgroundColor: '#637aff',
    borderRadius: 20,
    paddingVertical: 5,
    padding: 10,
    elevation: 2,
  },
});
